export default import.meta.ROLLDOWN_FILE_URL_UqgWuU74pwaSiWGhKsk0qw